var equalColumnHeightPlugin = require('./../../scripts/equalizeColumnHeights');

$(function () {
    //Equalize height of draw game detail promos
    if (!$('.column-layout-container').length) return;
    $('.column-layout-container .equal-height').equalizeColumnHeights();
});


// WEBPACK FOOTER //
// ./shared/components/column-layout/column-layout.js